import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import EmojiPicker from "../EmojiPicker";
import ReactionChip from "../../atoms/ReactionChip";
import CommentToggle from "../../atoms/CommentToggle";

import "./index.scss";

const PostEngagement = ({
    reactions,
    canReact,
    onToggleReaction,
    onEmojiSelect,
    commentsCount,
    canToggleComments,
    showComments,
    onToggleComments,
    className = "",
}) => {
    const hasReactions = reactions.length > 0;

    if (!hasReactions && !canReact && !canToggleComments) {
        return null;
    }

    return (
        <div className={classNames("post-engagement", className)} role="group" aria-label="Post interactions">
            <div className="post-engagement__reactions">
                {reactions.map((reaction) => (
                    <ReactionChip
                        key={reaction.emoji}
                        emoji={reaction.emoji}
                        count={reaction.count}
                        active={Boolean(reaction.reacted)}
                        disabled={!canReact}
                        onToggle={() => onToggleReaction(reaction.emoji, reaction.reacted)}
                    />
                ))}
                {canReact && (
                    <EmojiPicker onSelectEmoji={onEmojiSelect} />
                )}
            </div>
            <div className="post-engagement__actions">
                {canToggleComments && (
                    <CommentToggle
                        count={commentsCount}
                        active={showComments}
                        onToggle={onToggleComments}
                    />
                )}
            </div>
        </div>
    );
};

PostEngagement.propTypes = {
    reactions: PropTypes.arrayOf(PropTypes.shape({
        emoji: PropTypes.string.isRequired,
        count: PropTypes.number,
        reacted: PropTypes.bool,
    })),
    canReact: PropTypes.bool,
    onToggleReaction: PropTypes.func,
    onEmojiSelect: PropTypes.func,
    commentsCount: PropTypes.number,
    canToggleComments: PropTypes.bool,
    showComments: PropTypes.bool,
    onToggleComments: PropTypes.func,
    className: PropTypes.string,
};

PostEngagement.defaultProps = {
    reactions: [],
    canReact: false,
    onToggleReaction: () => {},
    onEmojiSelect: () => {},
    commentsCount: 0,
    canToggleComments: false,
    showComments: false,
    onToggleComments: () => {},
    className: "",
};

export default PostEngagement;
